export const PRICE_INCLUDE_VI = [
  "Chỗ ở theo loại phòng đã đề cập.",
  "Các bữa ăn như đã đề cập trong hành trình",
  "2 vé máy bay nội địa từ Hà Nội đến Đà Nẵng và Đà Nẵng - Hồ Chí Minh, bao gồm 20kg hành lý ký gửi và 7kg hành lý xách tay.",
  "Hướng dẫn viên nói tiếng Anh và xe đưa đón trong suốt chuyến tham quan như đã đề cập",
  "Phí vào cửa cho các điểm tham quan đã đề cập.",
  "Phí dịch vụ và thuế VAT.",
].join("\n");

export const PRICE_EXCLUDE_VI = [
  "Phí đóng dấu thị thực.",
  "Các bữa ăn khác ngoài lịch trình.",
  "Vé máy bay quốc tế đến và đi từ Việt Nam.",
  "Giặt ủi, điện thoại Chi phí cá nhân.",
  "Tiền boa cho hướng dẫn viên/tài xế.",
  "Bảo hiểm du lịch.",
].join("\n");

export const PRICE_TEMPLATE = `TOTAL 13,419 USD
13,419 USD for 17 adults, 4 kids staying at a mixture of 3, and 5 star accommodation as listed.
FIRST DEPOSIT 100 USD
Was paid to us by credit card with 4% bank fee converted into Vietnam Dong to secure the booking 4 March 2026
2ND DEPOSIT 6,600 USD
Was paid to us by credit card with 4% bank fee converted into Vietnam Dong or via bank transfer - bank fee is on your side before proceed booking.
FINAL BALANCE 6,719 USD
Will be paid in USD cash upon arrival`;
